export default "__VITE_ASSET__eom2mc8I__"